import React, { memo, useId } from 'react';

/**
 * Мини-чертёж прямоугольной детали.
 *
 * @param {Object}   props
 * @param {number?}  props.newPartWidth   – ширина в мм (null → «?»)
 * @param {number?}  props.newPartHeight  – высота  в мм (null → «?»)
 * @param {boolean}  [props.hasError]     – true ⇒ размеры красным
 */
function RectanglePreview({ newPartWidth, newPartHeight, hasError = false }) {
  const markerId = useId();                     // уникальный id для <marker>
  const dimColor = hasError ? '#ff4d4f' : 'black';
  const lineColor = '#4487C4'; // Sky Blue

  return (
    <svg
      viewBox="0 0 420 260"
      width="100%"
      style={{ maxWidth: '420px', height: 'auto' }}
      preserveAspectRatio="xMidYMid meet"
    >
      <defs>
        <marker
          id={markerId}
          viewBox="0 0 10 10"
          refX="10"
          refY="5"
          markerWidth="10"
          markerHeight="10"
          orient="auto-start-reverse"
          markerUnits="userSpaceOnUse"
        >
          <path d="M0 0L10 5L0 10Z" fill={lineColor} />
        </marker>
      </defs>

      {/* Размерные линии */}
      <line
        x1="90" y1="30" x2="370" y2="30"
        stroke={lineColor} strokeWidth="2"
        markerStart={`url(#${markerId})`}
        markerEnd={`url(#${markerId})`}
      />
      <line
        x1="60" y1="50" x2="60" y2="220"
        stroke={lineColor} strokeWidth="2"
        markerStart={`url(#${markerId})`}
        markerEnd={`url(#${markerId})`}
      />

      {/* Подписи размеров */}
      <text
        x="230" y="22" textAnchor="middle"
        fontFamily="Commissioner" fontSize="16" fontWeight="600"
        fill={dimColor}
      >
        {newPartWidth ? `${newPartWidth} мм` : '? мм'}
      </text>
      <text
        x="40" y="135" textAnchor="middle"
        fontFamily="Commissioner" fontSize="16" fontWeight="600"
        fill={dimColor}
        transform="rotate(-90 40 135)"
      >
        {newPartHeight ? `${newPartHeight} мм` : '? мм'}
      </text>

      {/* Контур детали */}
      <rect
        x="90" y="50" width="280" height="170"
        fill="none" stroke={lineColor} strokeWidth="2"
      />

      {/* Обозначения сторон */}
      <text
        x="230" y="75" textAnchor="middle" dominantBaseline="middle"
        fontFamily="Commissioner" fontSize="14" fontWeight="400"
        fill="black"
      >
        Сторона b
      </text>
      <text
        x="110" y="135" textAnchor="middle"
        fontFamily="Commissioner" fontSize="14" fontWeight="400"
        fill="black"
        transform="rotate(-90 110 135)"
      >
        Сторона a
      </text>
    </svg>
  );
}

export default memo(RectanglePreview);
